// drag_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["draggable", "dropzone", "ids"];

  connect() {
    this.setIds();
  }

  dragStart(event) {
    // Generate a unique ID by combining the original ID with a timestamp
    const originalId = event.currentTarget.dataset.id;
    const uniqueId = `${originalId}_${Date.now()}`;

    // Store both IDs in the dataTransfer
    event.dataTransfer.setData("text/plain", uniqueId);
    event.dataTransfer.setData("original-id", originalId);

    // Add the unique ID to the element temporarily
    event.currentTarget.dataset.tempId = uniqueId;
    event.currentTarget.classList.add("dragging");
  }

  dragOver(event) {
    event.preventDefault();
    const draggable = this.element.querySelector(".dragging");
    if (draggable && event.currentTarget === this.dropzoneTarget) {
      const afterElement = this.getAfterElement(event.currentTarget, event.clientY);
      if (afterElement == null) {
        event.currentTarget.appendChild(draggable);
      } else {
        event.currentTarget.insertBefore(draggable, afterElement);
      }
    }
  }

  drop(event) {
    event.preventDefault();
    const uniqueId = event.dataTransfer.getData("text/plain");
    const originalId = event.dataTransfer.getData("original-id");

    // Find the element using the temporary unique ID
    const draggable = this.element.querySelector(`[data-temp-id="${uniqueId}"]`);

    if (draggable) {
      // Reset to original state
      draggable.classList.remove("dragging");
      delete draggable.dataset.tempId;

      // Make sure the original ID is preserved
      draggable.dataset.id = originalId;
    }

    this.setIds();
  }

  remove(event) {
    event.preventDefault();
    const item = event.currentTarget.closest('[data-drag-target="draggable"]');
    item.remove();
    this.setIds();
  }

  // Helper method to determine where to insert the dragged item
  getAfterElement(container, y) {
    const draggableElements = [
      ...container.querySelectorAll('[data-drag-target="draggable"]:not(.dragging)'),
    ];

    return draggableElements.reduce(
      (closest, child) => {
        const box = child.getBoundingClientRect();
        const offset = y - box.top - box.height / 2;
        if (offset < 0 && offset > closest.offset) {
          return { offset: offset, element: child };
        }
        return closest;
      },
      { offset: Number.NEGATIVE_INFINITY }
    ).element;
  }

  setIds() {
    if (this.hasIdsTarget) {
      this.idsTarget.value = JSON.stringify(
        Array.from(this.dropzoneTarget.children).map((child) => child.dataset.id)
      );
    }
  }
}
